import { svg } from "lit";
const icon = svg `<path d="M3.41699 17.5836V7.74387H2.41699V2.41699H17.5836V7.74387H16.5836V17.5836H3.41699ZM4.5003 16.5003H15.5003V7.74387H4.5003V16.5003ZM3.5003 6.66058H16.5003V3.50031H3.5003V6.66058ZM8.16058 11.0275H11.84V10.0003H8.16058V11.0275Z" fill="currentColor"/>`;
export default icon;
